module.exports = __webpack_public_path__ + "img/equip-bottom.3d76ad8b.jpg";